import React from "react";
import type { SpecsModel } from "../../specsModel/SpecsModel";
import { useSpecsModel, useSpecsModelSelector } from "../../SpecsModelContext";
import { SpecsSelectField } from "../../SpecsEditorFields/index";

type SpecsModelSelectFieldProps = Omit<
  React.ComponentProps<typeof SpecsSelectField>,
  "value" | "onChange"
> & {
  selector: (model: SpecsModel) => string;
  setValue: (model: SpecsModel, nextValue: string) => void;
};

export default function SpecsModelSelectField({
  selector,
  setValue,
  ...props
}: SpecsModelSelectFieldProps) {
  const model = useSpecsModel();
  const value = useSpecsModelSelector(selector);

  const handleChange = React.useCallback(
    (nextValue: string) => {
      setValue(model, nextValue);
    },
    [model, setValue]
  );

  return <SpecsSelectField {...props} value={value} onChange={handleChange} />;
}
